module.exports = __webpack_public_path__ + "static/media/16.86320084.jpg";